/**
 * Static content for the Contact Us page.
 * Copy lives here so the page/components stay logic-light.
 */
const ContactPage = {
  seo: {
    title: 'Contact Us',
    description:
      'Get in touch with the VoteWise team — send us a message and we will respond as soon as possible.',
  },
  backToHomeLabel: 'Back to Home',
  heading: 'Contact Us',
  /**
   * Appended to the labels of the three fields the API treats as `nullable`
   * (VTW-439 made everything but Message optional), so the low-friction form
   * says so rather than leaving people to guess.
   */
  optionalSuffix: '(optional)',
  intro:
    "Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
  fields: {
    firstName: {
      label: 'First Name',
      placeholder: 'John',
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'John',
    },
    email: {
      label: 'Email Address',
      placeholder: 'john@example.com',
    },
    message: {
      label: 'Message',
      placeholder: 'How can we help you?',
    },
  },
  messageMaxLength: 280,
  submitLabel: 'Send Message',
  submittingLabel: 'Sending...',
  consent: {
    prefix: 'By submitting this form, you agree to our ',
    linkLabel: 'Privacy Policy',
    suffix: '.',
  },
  successTitle: 'Message sent!',
  successMessage:
    "Thanks for reaching out. We've received your message and will get back to you as soon as possible.",
  sendAnotherLabel: 'Send another message',
  contact: {
    /**
     * Path appended to the API base URL (which already includes `/api/v1`),
     * resolving to `<API_BASE_URL>/contact-us` — the route the API actually
     * exposes (`api/v1/contact-us`).
     */
    path: 'contact-us',
  },
};

export default ContactPage;
